import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_2 = { class: "mt-1 break-words" };
const _hoisted_3 = ["href", "aria-disabled", "tabindex"];
const _hoisted_4 = {
    key: 2,
    class: "text-sm font-medium text-gray-400 dark:text-gray-500"
};
import { computed } from "vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PropertyRow',
    props: {
        label: {},
        value: { default: null },
        variant: { default: "plain" },
        href: { default: null }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const hasValue = computed(() => !!props.value && props.value.length > 0);
        const displayValue = computed(() => (hasValue.value ? props.value : t("common.placeholder")));
        const shellClasses = computed(() => [
            "flex items-center w-full rounded-xl border border-solid box-border",
            "h-[36px] px-3 py-2 gap-2",
            "bg-(--background-background-white) border-(--border-border-base-medium)",
            "dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base)",
        ]);
        const valueTextClasses = computed(() => hasValue.value
            ? "text-text-black-default dark:text-(--colors-text-white-default)"
            : "text-slategray dark:text-(--colors-text-white-secondary)");
        function onLinkClick(event) {
            // Without a real target we still want keyboard / screen-reader semantics,
            // so we render the anchor but stop the default navigation.
            if (!props.href) {
                event.preventDefault();
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("dt", _hoisted_1, _toDisplayString(__props.label), 1 /* TEXT */),
                _createElementVNode("dd", _hoisted_2, [
                    (__props.variant === 'shell')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(shellClasses.value),
                            "data-testid": "property-row-shell"
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["flex-1 truncate text-sm leading-5", valueTextClasses.value])
                            }, [
                                _renderSlot(_ctx.$slots, "default", {}, () => [
                                    _createTextVNode(_toDisplayString(displayValue.value), 1 /* TEXT */)
                                ])
                            ], 2 /* CLASS */),
                            _cache[0] || (_cache[0] = _createElementVNode("i", {
                                class: "ri-arrow-down-s-line shrink-0 text-base leading-none text-text-body-subtle dark:text-(--colors-text-white-secondary)",
                                "aria-hidden": "true"
                            }, null, -1 /* CACHED */))
                        ], 2 /* CLASS */))
                        : (__props.variant === 'link' && hasValue.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: __props.href ?? '#',
                                class: "text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline dark:text-blue-400 dark:hover:text-blue-300",
                                "aria-disabled": !__props.href || undefined,
                                tabindex: __props.href ? undefined : -1,
                                "data-testid": "property-row-link",
                                onClick: onLinkClick
                            }, [
                                _renderSlot(_ctx.$slots, "default", {}, () => [
                                    _createTextVNode(_toDisplayString(displayValue.value), 1 /* TEXT */)
                                ])
                            ], 8 /* PROPS */, _hoisted_3))
                            : (__props.variant === 'link')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(displayValue.value), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 3,
                                    class: _normalizeClass(["text-sm font-medium text-gray-900 dark:text-white", { 'text-gray-400 dark:text-gray-500': !hasValue.value && !_ctx.$slots.default }])
                                }, [
                                    _renderSlot(_ctx.$slots, "default", {}, () => [
                                        _createTextVNode(_toDisplayString(displayValue.value), 1 /* TEXT */)
                                    ])
                                ], 2 /* CLASS */))
                ])
            ]));
        };
    }
});
